// AUTO-GENERATED from docs/TECHNICAL_PRD.md — CID Agent PWA API layer
// Module: Notifications (in-app centre + Web Push)
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * GET /api/agent/notifications [LIST · paginated]
 * Paginated in-app notification centre feed for the caller agent.
 * @disposition BUILD_NEW
 */
export const listNotifications = (params = {}) => client.get(`/api/agent/notifications`, { params });

/**
 * GET /api/agent/notifications/unread-count [LIST · paginated]
 * Lightweight badge count for PWA nav + push-icon badge sync.
 * @disposition BUILD_NEW
 */
export const listNotificationsUnreadCount = (params = {}) => client.get(`/api/agent/notifications/unread-count`, { params });

/**
 * PATCH /api/agent/notifications/:id/read
 * Mark a single notification read (idempotent).
 * @disposition BUILD_NEW
 */
export const patchNotificationsReadById = (id, data = {}) => client.patch(`/api/agent/notifications/${id}/read`, data);

/**
 * PATCH /api/agent/notifications/read-all
 * Mark all as read to clear the badge.
 * @disposition BUILD_NEW
 */
export const patchNotificationsReadAll = (data = {}) => client.patch(`/api/agent/notifications/read-all`, data);

/**
 * GET /api/agent/notifications/preferences
 * Returns { pushOn } — whether this agent has an active Web Push subscription.
 * There are no stored notification preferences any more (category mutes were
 * removed; every notification is always delivered), so this is purely a push
 * probe. The `/preferences` path is kept so cached PWA builds keep working.
 * @disposition BUILD_NEW
 */
export const getNotificationsPushStatus = (params = {}) => client.get(`/api/agent/notifications/preferences`, { params });

/**
 * GET /api/agent/push/public-key
 * VAPID public key the PWA passes to pushManager.subscribe().
 * @disposition BUILD_NEW
 */
export const getPushPublicKey = () => client.get(`/api/agent/push/public-key`);

/**
 * POST /api/agent/push/register
 * Register a Web Push subscription (or FCM token) for the caller's device so dispatch can deliver push.
 * @disposition BUILD_NEW
 */
export const createPushRegister = (data = {}) => client.post(`/api/agent/push/register`, data);

/**
 * DELETE /api/agent/push/unregister
 * Remove/deactivate a device subscription on logout or unsubscribe.
 * @disposition BUILD_NEW
 */
export const deletePushUnregister = (config = {}) => client.delete(`/api/agent/push/unregister`, config);
